export const mergeRaisedIssueTags = ({ allTags = [], issueTags = [], tagNames = [], noIssueTagType }) => {
   const merged = [...allTags];

   issueTags.forEach((issueTag, index) => {
      const noTag = issueTag && (issueTag.noTag != null ? issueTag.noTag : issueTag.no);
      const name = (issueTag && issueTag.name) || tagNames[index];
      if (noTag == null || !name) return;

      const existingIndex = merged.findIndex((tag) => String(tag.noTag != null ? tag.noTag : tag.no) === String(noTag));
      const nextTag = {
         ...(existingIndex >= 0 ? merged[existingIndex] : {}),
         ...issueTag,
         noTag,
         name,
         noTagType: issueTag.noTagType == null ? noIssueTagType : issueTag.noTagType
      };

      if (existingIndex >= 0) merged[existingIndex] = nextTag;
      else merged.push(nextTag);
   });

   return merged;
};
